var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTripDates = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 84,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5CC9E6",
  d: "M6.586 14.586a2 2 0 0 0 2.828 0l5.172-5.172a2 2 0 0 0 0-2.828L9.414 1.414a2 2 0 0 0-2.828 0L1.414 6.586a2 2 0 0 0 0 2.828zM6.586 21.414a2 2 0 1 0 2.828-2.828 2 2 0 0 0-2.828 2.828M6.586 56.414a2 2 0 1 0 2.828-2.828 2 2 0 0 0-2.828 2.828M6.586 29.414a2 2 0 1 0 2.828-2.828 2 2 0 0 0-2.828 2.828M6.586 64.414a2 2 0 1 0 2.828-2.828 2 2 0 0 0-2.828 2.828M6.586 82.586a2 2 0 0 0 2.828 0l5.172-5.172a2 2 0 0 0 0-2.828l-5.172-5.172a2 2 0 0 0-2.828 0l-5.172 5.172a2 2 0 0 0 0 2.828z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 15,
  x: 6,
  y: 34,
  fill: "#5CC9E6",
  rx: 2
})));
export default SvgTripDates;